// extracted by mini-css-extract-plugin
module.exports = {"products":"pT","productContainer":"qT","resultsHeading":"rT","oosMessaging":"sT"};